import React from 'react';

const Footer = () => {
  return (
    <div className="w-full bg-white shadow-md text-justify px-6 py-4 text-base text-gray-600">
      <h3 className="font-semibold text-text mb-2">Trading carries a high level of risk.</h3>
      <p>
        Trading involves risk. Over-the-counter (OTC) margined derivatives, including Contracts for Difference (CFDs) and spot foreign exchange, are complex financial instruments. Due to leverage, they pose a significant risk of rapid losses. Before trading, ensure you fully understand these products, assess your ability to bear potential losses, and evaluate your risk tolerance. Seeking professional financial advice is strongly recommended.
      </p>
      <p className="mt-4">
        INVESTAiN Ltd is licensed and regulated by the Financial Services Commission (FSC) of Mauritius, under License No: 
        <a 
          href="https://opr.fscmauritius.org/ords/opr/r/fsc-opr/fsc-online-public-register-opr?" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-primary hover:underline"
        >
          GB24202963
        </a>.
      </p>
    </div>
  );
};

export default Footer;
